module.exports = __webpack_public_path__ + "img/consult_list4.c8988536.png";